export const sheets_en = {
  sheets_more_actions: "More actions",
  sheets_history: "Delivery history",
  sheets_remove_column: "Remove column {name}",

  sheet_capability_manual_add: "Add contacts manually",
  sheet_capability_import: "Import contacts",
  sheets_source_all_contacts: "All contacts",
  sheets_source_auto_fill: "Auto-fill sheet",
  sheets_source_manual: "Manual sheet",
  sheets_source_service: "From a Custom Data Request",
  sheets_latest_delivery: "Latest delivery {date}",
  sheet_capability_edit: "Edit contacts",
  sheet_capability_export: "Export",
  crm_edit_contact: "Edit contact",
  create_row_above: "Create contact above",
  create_row_below: "Create contact below",
  crm_add_enrichment: "Add enrichment",
  crm_customize_view: "Customize view",
  text: "Text",
  number: "Number",
  filter_on_this_column: "Filter on this column",
  hide: "Hide",
  quick_action: "Quick Actions",
  crm_auto_sync: "Auto-sync",
  auto_sync_drawer_title: "Auto-sync settings",
  crm_segmented_filters: "Segment Filters",
  segmented_filters_drawer_title: "Segments",
  new_segmented_view: "New segment view",
  add_condition: "Add condition",
  sorts: "Sorts",
  add_sort: "Add sort",
  save_state_default: "Autosave",
  save_state_saved: "All changes saved",
  save_state_saving: "Saving changes…",
  save_state_not_saved: "Changes not saved",
  save_state_offline: "Offline",

  limited_selection_select_rows_from: "Select rows from",
  selected_count: "{count} selected",

  crm_column_visibility_dialog_title: "Customized View",
  crm_column_visibility_dialog_desc:
    "Choose the data fields you want to display in this table.",
  crm_column_visibility_dialog_tips:
    "Don’t see the property you’re looking for? ",
  crm_column_visibility_dialog_available_fields: "Available Fields",
  crm_column_visibility_dialog_no_fields_title: "No fields available",

  crm_column_visibility_dialog_no_fields_desc:
    "There are no additional fields to add right now. Try adding new properties or enrichment fields to expand your table options.",

  crm_column_visibility_dialog_fields_order:
    "Selected Fields (Drag to reorder)",

  sheets: "Sheets",
  sheets_description:
    "Manage your contacts and companies in one organized workspace.",

  crm_delete_column_warning_dialog_title: 'Delete Column "{name}"',
  crm_delete_column_warning_dialog_para1: "You’re about to delete this column.",
  crm_delete_column_warning_dialog_para2:
    "This action cannot be undone. Please confirm if you want to proceed with deleting this column.",

  crm_delete_row_warning_dialog_title: "Delete Record",
  crm_delete_row_warning_dialog_para1: "You’re about to delete this record.",
  crm_delete_row_warning_dialog_para2:
    "This action cannot be undone. Please confirm if you want to proceed with deleting this record.",

  // Sheet capability popover
  sheet_type_autofill: "Auto-fill sheet",
  sheet_capability_title: "capabilities",
  sheet_capability_contact_enrichment: "Contact enrichment",
  sheet_capability_autofill_rules: "Auto-fill with rules",
  sheet_capability_autosync_sequences: "Auto-sync to sequences",
  sheet_capability_manual_add_import: "Manual add & import",
  sheet_edit_description: "Edit description",
  sheet_rename: "Rename sheet",
  sheet_duplicate: "Duplicate sheet",
  sheet_delete: "Delete sheet",

  sheets_loading_contacts: "Loading contacts…",
  sheets_contacts_error: "Unable to load this Sheet.",
  sheets_retry: "Retry",
  sheets_empty_contacts: "This Sheet has no contacts yet.",
  sheets_empty_contacts_desc:
    "Add or import contacts to start filling this sheet.",
  sheets_empty_contacts_readonly_desc:
    "Contacts appear here once this sheet receives them.",
  sheets_sort_ascending: "Ascending",
  includes_any: "Includes any",
  sheets_sort_descending: "Descending",
  sheets_filter_remove: "Remove filter",
  sheets_filter_on_column: "Filter on this column",
  sheets_close: "Close",
  sheets_filter_empty: "No filters yet. Add one to narrow this Sheet.",
  sheets_remove_sort: "Remove this sort",
  sheets_move_sort_up: "Move {name} sort earlier",
  sheets_move_sort_down: "Move {name} sort later",
  sheets_column_sorted_ascending: "{name}, sorted ascending",
  sheets_column_sorted_descending: "{name}, sorted descending",
  sheets_column_not_sorted: "{name}, not sorted",
  sheets_no_result_title: "No contacts match this view",
  sheets_rows_forbidden_title: "You cannot view these contacts",
  sheets_rows_forbidden_desc:
    "Your account is not allowed to see the contacts in this sheet.",
  sheets_loading_list: "Loading Sheets…",
  sheets_list_error: "Unable to load Sheets.",
  sheets_empty_list: "No Sheets are available.",
  sheets_loading_schema: "Loading Sheet fields…",
  sheets_schema_error: "Unable to load Sheet fields.",
  sheets_loading_configuration: "Loading Sheet settings…",
  sheets_configuration_error: "Unable to load this Sheet's settings.",
  sheets_new_sheet_name: "New Sheet",
  sheets_empty_list_desc:
    "Sheets you create, or receive from a Custom Data Request, appear here.",
  sheets_not_found_title: "Sheet not found",
  sheets_not_found_desc: "This Sheet does not exist, or it has been deleted.",
  sheets_forbidden_title: "You do not have access to this Sheet",
  sheets_forbidden_desc: "Your account does not have permission to open it.",
  sheets_untitled_sheet: "Untitled Sheet",
  sheets_error_retry_desc:
    "This is usually temporary. Try again in a moment.",
  sheets_contacts_error_final_desc:
    "Trying again will not change this. Contact support if it continues.",
  sheets_toggle_switcher: "Show or hide the Sheet list",
};

export const sheets_zhCn = {
  sheets_more_actions: "更多操作",
  sheets_history: "交付记录",
  sheets_remove_column: "移除列 {name}",

  sheets: "表格",
  sheets_description:
    "在一个有条理的工作区中管理您的联系人和公司。",

  sheet_capability_manual_add: "手动添加联系人",
  sheet_capability_import: "导入联系人",
  sheets_source_all_contacts: "全部联系人",
  sheets_source_auto_fill: "自动填充工作表",
  sheets_source_manual: "手动工作表",
  sheets_source_service: "来自定制数据请求",
  sheets_latest_delivery: "最近交付 {date}",
  sheet_capability_edit: "编辑联系人",
  sheet_capability_export: "导出",
  sheets_loading_contacts: "正在加载联系人…",
  sheets_contacts_error: "无法加载此工作表。",
  sheets_retry: "重试",
  sheets_empty_contacts: "此工作表中暂无联系人。",
  sheets_empty_contacts_desc: "添加或导入联系人，即可开始填充此工作表。",
  sheets_empty_contacts_readonly_desc: "此工作表收到联系人后，会显示在这里。",
  sheets_sort_ascending: "升序",
  includes_any: "包含任一",
  sheets_sort_descending: "降序",
  sheets_filter_remove: "移除筛选",
  sheets_filter_on_column: "按此列筛选",
  sheets_close: "关闭",
  sheets_filter_empty: "尚无筛选条件。添加一个以缩小此工作表范围。",
  sheets_remove_sort: "移除此排序",
  sheets_move_sort_up: "将{name}排序前移",
  sheets_move_sort_down: "将{name}排序后移",
  sheets_column_sorted_ascending: "{name}，已升序排列",
  sheets_column_sorted_descending: "{name}，已降序排列",
  sheets_column_not_sorted: "{name}，未排序",
  sheets_no_result_title: "没有符合此视图的联系人",
  sheets_rows_forbidden_title: "您无法查看这些联系人",
  sheets_rows_forbidden_desc: "您的账号没有权限查看此工作表中的联系人。",
  sheets_loading_list: "正在加载工作表…",
  sheets_list_error: "无法加载工作表。",
  sheets_empty_list: "暂无可用工作表。",
  sheets_loading_schema: "正在加载工作表字段…",
  sheets_schema_error: "无法加载工作表字段。",
  sheets_loading_configuration: "正在加载工作表设置…",
  sheets_configuration_error: "无法加载此工作表的设置。",
  sheets_new_sheet_name: "新建工作表",
  sheets_empty_list_desc: "您创建或通过定制数据请求收到的工作表会显示在这里。",
  sheets_not_found_title: "未找到工作表",
  sheets_not_found_desc: "此工作表不存在，或已被删除。",
  sheets_forbidden_title: "您无权访问此工作表",
  sheets_forbidden_desc: "您的账号没有打开此工作表的权限。",
  sheets_untitled_sheet: "未命名工作表",
  sheets_error_retry_desc: "这通常是暂时的，请稍后重试。",
  sheets_contacts_error_final_desc: "重试也不会改变结果。如果持续出现，请联系客服。",
  sheets_toggle_switcher: "显示或隐藏工作表列表",
};

export const sheets_zhTw = {
  sheets_more_actions: "更多操作",
  sheets_history: "交付紀錄",
  sheets_remove_column: "移除欄位 {name}",

  sheets: "表格",
  sheets_description:
    "在一個有條理的工作區中管理您的聯絡人和公司。",

  sheet_capability_manual_add: "手動新增聯絡人",
  sheet_capability_import: "匯入聯絡人",
  sheets_source_all_contacts: "全部聯絡人",
  sheets_source_auto_fill: "自動填入工作表",
  sheets_source_manual: "手動工作表",
  sheets_source_service: "來自客製資料請求",
  sheets_latest_delivery: "最近交付 {date}",
  sheet_capability_edit: "編輯聯絡人",
  sheet_capability_export: "匯出",
  sheets_loading_contacts: "正在載入聯絡人…",
  sheets_contacts_error: "無法載入此工作表。",
  sheets_retry: "重試",
  sheets_empty_contacts: "此工作表中尚無聯絡人。",
  sheets_empty_contacts_desc: "新增或匯入聯絡人，即可開始填入此工作表。",
  sheets_empty_contacts_readonly_desc: "此工作表收到聯絡人後，會顯示在這裡。",
  sheets_sort_ascending: "升序",
  includes_any: "包含任一",
  sheets_sort_descending: "降序",
  sheets_filter_remove: "移除篩選",
  sheets_filter_on_column: "依此欄篩選",
  sheets_close: "關閉",
  sheets_filter_empty: "尚無篩選條件。新增一個以縮小此工作表範圍。",
  sheets_remove_sort: "移除此排序",
  sheets_move_sort_up: "將{name}排序前移",
  sheets_move_sort_down: "將{name}排序後移",
  sheets_column_sorted_ascending: "{name}，已升冪排列",
  sheets_column_sorted_descending: "{name}，已降冪排列",
  sheets_column_not_sorted: "{name}，未排序",
  sheets_no_result_title: "沒有符合此檢視的聯絡人",
  sheets_rows_forbidden_title: "您無法檢視這些聯絡人",
  sheets_rows_forbidden_desc: "您的帳號沒有權限檢視此工作表中的聯絡人。",
  sheets_loading_list: "正在載入工作表…",
  sheets_list_error: "無法載入工作表。",
  sheets_empty_list: "目前沒有可用的工作表。",
  sheets_loading_schema: "正在載入工作表欄位…",
  sheets_schema_error: "無法載入工作表欄位。",
  sheets_loading_configuration: "正在載入工作表設定…",
  sheets_configuration_error: "無法載入此工作表的設定。",
  sheets_new_sheet_name: "新增工作表",
  sheets_empty_list_desc: "您建立或透過訂製資料請求收到的工作表會顯示在這裡。",
  sheets_not_found_title: "找不到工作表",
  sheets_not_found_desc: "此工作表不存在，或已被刪除。",
  sheets_forbidden_title: "您沒有存取此工作表的權限",
  sheets_forbidden_desc: "您的帳號沒有開啟此工作表的權限。",
  sheets_untitled_sheet: "未命名工作表",
  sheets_error_retry_desc: "這通常是暫時的，請稍後再試。",
  sheets_contacts_error_final_desc: "重試也不會改變結果。若持續發生，請聯絡客服。",
  sheets_toggle_switcher: "顯示或隱藏工作表清單",
};

export const sheets_ja = {
  sheets_more_actions: "その他の操作",
  sheets_history: "配信履歴",
  sheets_remove_column: "列 {name} を削除",

  sheets: "シート",
  sheets_description:
    "連絡先と企業を一つの整理されたワークスペースで管理します。",

  sheet_capability_manual_add: "連絡先を手動で追加",
  sheet_capability_import: "連絡先をインポート",
  sheets_source_all_contacts: "すべての連絡先",
  sheets_source_auto_fill: "自動入力シート",
  sheets_source_manual: "手動シート",
  sheets_source_service: "カスタムデータリクエストから",
  sheets_latest_delivery: "最新の納品 {date}",
  sheet_capability_edit: "連絡先を編集",
  sheet_capability_export: "エクスポート",
  sheets_loading_contacts: "連絡先を読み込んでいます…",
  sheets_contacts_error: "このシートを読み込めません。",
  sheets_retry: "再試行",
  sheets_empty_contacts: "このシートにはまだ連絡先がありません。",
  sheets_empty_contacts_desc:
    "連絡先を追加またはインポートすると、このシートに入力できます。",
  sheets_empty_contacts_readonly_desc:
    "このシートに連絡先が届くと、ここに表示されます。",
  sheets_sort_ascending: "昇順",
  includes_any: "いずれかを含む",
  sheets_sort_descending: "降順",
  sheets_filter_remove: "フィルターを削除",
  sheets_filter_on_column: "この列で絞り込む",
  sheets_close: "閉じる",
  sheets_filter_empty: "フィルターはまだありません。追加してシートを絞り込みます。",
  sheets_remove_sort: "この並べ替えを削除",
  sheets_move_sort_up: "{name}の並べ替えを前へ",
  sheets_move_sort_down: "{name}の並べ替えを後ろへ",
  sheets_column_sorted_ascending: "{name}、昇順で並べ替え済み",
  sheets_column_sorted_descending: "{name}、降順で並べ替え済み",
  sheets_column_not_sorted: "{name}、並べ替えなし",
  sheets_no_result_title: "このビューに一致する連絡先はありません",
  sheets_rows_forbidden_title: "これらの連絡先は表示できません",
  sheets_rows_forbidden_desc:
    "お使いのアカウントには、このシートの連絡先を見る権限がありません。",
  sheets_loading_list: "シートを読み込んでいます…",
  sheets_list_error: "シートを読み込めません。",
  sheets_empty_list: "利用できるシートがありません。",
  sheets_loading_schema: "シートのフィールドを読み込んでいます…",
  sheets_schema_error: "シートのフィールドを読み込めません。",
  sheets_loading_configuration: "シート設定を読み込んでいます…",
  sheets_configuration_error: "このシートの設定を読み込めません。",
  sheets_new_sheet_name: "新しいシート",
  sheets_empty_list_desc:
    "作成したシートやカスタムデータリクエストで受け取ったシートがここに表示されます。",
  sheets_not_found_title: "シートが見つかりません",
  sheets_not_found_desc: "このシートは存在しないか、削除されました。",
  sheets_forbidden_title: "このシートへのアクセス権がありません",
  sheets_forbidden_desc: "お使いのアカウントには開く権限がありません。",
  sheets_untitled_sheet: "無題のシート",
  sheets_error_retry_desc: "一時的な問題です。しばらくしてから再度お試しください。",
  sheets_contacts_error_final_desc:
    "再試行しても結果は変わりません。続く場合はサポートにご連絡ください。",
  sheets_toggle_switcher: "シート一覧の表示を切り替える",
};

export const sheets_hi = {
  sheets_more_actions: "और विकल्प",
  sheets_history: "डिलीवरी इतिहास",
  sheets_remove_column: "कॉलम {name} हटाएं",

  sheets: "शीट्स",
  sheets_description:
    "अपने संपर्कों और कंपनियों को एक व्यवस्थित कार्यक्षेत्र में प्रबंधित करें।",

  sheet_capability_manual_add: "संपर्क मैन्युअल रूप से जोड़ें",
  sheet_capability_import: "संपर्क आयात करें",
  sheets_source_all_contacts: "सभी संपर्क",
  sheets_source_auto_fill: "ऑटो-फ़िल शीट",
  sheets_source_manual: "मैन्युअल शीट",
  sheets_source_service: "कस्टम डेटा अनुरोध से",
  sheets_latest_delivery: "नवीनतम डिलीवरी {date}",
  sheet_capability_edit: "संपर्क संपादित करें",
  sheet_capability_export: "एक्सपोर्ट",
  sheets_loading_contacts: "संपर्क लोड हो रहे हैं…",
  sheets_contacts_error: "यह शीट लोड नहीं हो सकी।",
  sheets_retry: "पुनः प्रयास करें",
  sheets_empty_contacts: "इस शीट में अभी कोई संपर्क नहीं है।",
  sheets_empty_contacts_desc:
    "इस शीट को भरना शुरू करने के लिए संपर्क जोड़ें या इंपोर्ट करें।",
  sheets_empty_contacts_readonly_desc:
    "इस शीट में संपर्क आने पर वे यहाँ दिखेंगे।",
  sheets_sort_ascending: "आरोही",
  includes_any: "इनमें से कोई शामिल है",
  sheets_sort_descending: "अवरोही",
  sheets_filter_remove: "फ़िल्टर हटाएं",
  sheets_filter_on_column: "इस कॉलम पर फ़िल्टर करें",
  sheets_close: "बंद करें",
  sheets_filter_empty: "अभी कोई फ़िल्टर नहीं है। इस शीट को सीमित करने के लिए एक जोड़ें।",
  sheets_remove_sort: "यह क्रमबद्धता हटाएं",
  sheets_move_sort_up: "{name} क्रमबद्धता ऊपर ले जाएं",
  sheets_move_sort_down: "{name} क्रमबद्धता नीचे ले जाएं",
  sheets_column_sorted_ascending: "{name}, आरोही क्रम में",
  sheets_column_sorted_descending: "{name}, अवरोही क्रम में",
  sheets_column_not_sorted: "{name}, क्रमबद्ध नहीं",
  sheets_no_result_title: "इस व्यू से कोई संपर्क मेल नहीं खाता",
  sheets_rows_forbidden_title: "आप ये संपर्क नहीं देख सकते",
  sheets_rows_forbidden_desc:
    "आपके खाते को इस शीट के संपर्क देखने की अनुमति नहीं है।",
  sheets_loading_list: "शीट लोड हो रही हैं…",
  sheets_list_error: "शीट लोड नहीं हो सकीं।",
  sheets_empty_list: "कोई शीट उपलब्ध नहीं है।",
  sheets_loading_schema: "शीट फ़ील्ड लोड हो रहे हैं…",
  sheets_schema_error: "शीट फ़ील्ड लोड नहीं हो सके।",
  sheets_loading_configuration: "शीट सेटिंग लोड हो रही हैं…",
  sheets_configuration_error: "इस शीट की सेटिंग लोड नहीं हो सकीं।",
  sheets_new_sheet_name: "नई शीट",
  sheets_empty_list_desc:
    "आपकी बनाई या कस्टम डेटा रिक्वेस्ट से मिली शीट यहाँ दिखेंगी।",
  sheets_not_found_title: "शीट नहीं मिली",
  sheets_not_found_desc: "यह शीट मौजूद नहीं है, या इसे हटा दिया गया है।",
  sheets_forbidden_title: "आपके पास इस शीट का एक्सेस नहीं है",
  sheets_forbidden_desc: "आपके खाते को इसे खोलने की अनुमति नहीं है।",
  sheets_untitled_sheet: "बिना नाम की शीट",
  sheets_error_retry_desc:
    "यह आमतौर पर अस्थायी होता है। कुछ देर बाद फिर कोशिश करें।",
  sheets_contacts_error_final_desc:
    "दोबारा कोशिश करने से नतीजा नहीं बदलेगा। बना रहे तो सपोर्ट से संपर्क करें।",
  sheets_toggle_switcher: "शीट सूची दिखाएँ या छिपाएँ",
};

export const sheets_ko = {
  sheets_more_actions: "추가 작업",
  sheets_history: "전송 기록",
  sheets_remove_column: "{name} 열 제거",

  sheets: "시트",
  sheets_description:
    "연락처와 회사를 하나의 정리된 작업 공간에서 관리하세요.",

  sheet_capability_manual_add: "연락처 직접 추가",
  sheet_capability_import: "연락처 가져오기",
  sheets_source_all_contacts: "전체 연락처",
  sheets_source_auto_fill: "자동 채우기 시트",
  sheets_source_manual: "수동 시트",
  sheets_source_service: "맞춤 데이터 요청에서",
  sheets_latest_delivery: "최근 전달 {date}",
  sheet_capability_edit: "연락처 편집",
  sheet_capability_export: "내보내기",
  sheets_loading_contacts: "연락처를 불러오는 중…",
  sheets_contacts_error: "이 시트를 불러올 수 없습니다.",
  sheets_retry: "다시 시도",
  sheets_empty_contacts: "이 시트에는 아직 연락처가 없습니다.",
  sheets_empty_contacts_desc: "연락처를 추가하거나 가져와 이 시트를 채워 보세요.",
  sheets_empty_contacts_readonly_desc: "이 시트에 연락처가 들어오면 여기에 표시됩니다.",
  sheets_sort_ascending: "오름차순",
  includes_any: "다음 중 하나 포함",
  sheets_sort_descending: "내림차순",
  sheets_filter_remove: "필터 제거",
  sheets_filter_on_column: "이 열로 필터",
  sheets_close: "닫기",
  sheets_filter_empty: "아직 필터가 없습니다. 추가하여 이 시트를 좁히세요.",
  sheets_remove_sort: "이 정렬 제거",
  sheets_move_sort_up: "{name} 정렬을 위로",
  sheets_move_sort_down: "{name} 정렬을 아래로",
  sheets_column_sorted_ascending: "{name}, 오름차순 정렬됨",
  sheets_column_sorted_descending: "{name}, 내림차순 정렬됨",
  sheets_column_not_sorted: "{name}, 정렬 안 됨",
  sheets_no_result_title: "이 보기와 일치하는 연락처가 없습니다",
  sheets_rows_forbidden_title: "이 연락처를 볼 수 없습니다",
  sheets_rows_forbidden_desc:
    "회원님의 계정에는 이 시트의 연락처를 볼 권한이 없습니다.",
  sheets_loading_list: "시트를 불러오는 중…",
  sheets_list_error: "시트를 불러올 수 없습니다.",
  sheets_empty_list: "사용 가능한 시트가 없습니다.",
  sheets_loading_schema: "시트 필드를 불러오는 중…",
  sheets_schema_error: "시트 필드를 불러올 수 없습니다.",
  sheets_loading_configuration: "시트 설정을 불러오는 중…",
  sheets_configuration_error: "이 시트의 설정을 불러올 수 없습니다.",
  sheets_new_sheet_name: "새 시트",
  sheets_empty_list_desc:
    "직접 만들었거나 커스텀 데이터 요청으로 받은 시트가 여기에 표시됩니다.",
  sheets_not_found_title: "시트를 찾을 수 없습니다",
  sheets_not_found_desc: "이 시트가 없거나 삭제되었습니다.",
  sheets_forbidden_title: "이 시트에 접근할 권한이 없습니다",
  sheets_forbidden_desc: "이 시트를 열 권한이 계정에 없습니다.",
  sheets_untitled_sheet: "제목 없는 시트",
  sheets_error_retry_desc: "일시적인 문제입니다. 잠시 후 다시 시도하세요.",
  sheets_contacts_error_final_desc:
    "다시 시도해도 결과는 같습니다. 계속되면 고객지원에 문의하세요.",
  sheets_toggle_switcher: "시트 목록 표시 전환",
};
